import { createContext, useContext } from 'react';
import { settings } from 'config';

const AppContext = createContext(settings);

export const useAppContext = () => {
  const {
    config: { isFluid, isRTL, isDark },
    setConfig
  } = useContext(AppContext);

  return {
    isFluid,
    isRTL,
    isDark,
    setConfig
  };
};

export default AppContext;
